module.exports = __webpack_public_path__ + "96ef1c40ebb78d79d9f12ae516144041.pdf";